import type { RefObject, ChangeEvent as ReactChangeEvent } from "react";
import styles from "./Input.module.css";

type TextInputRef = RefObject<HTMLInputElement>;
type TextAreaRef = RefObject<HTMLTextAreaElement>;

type ChangeEvent = ReactChangeEvent<HTMLInputElement | HTMLTextAreaElement>;

interface Props {
  id?: string;
  name?: string;
  type?: string;
  required?: boolean;
  onBlur?: (e: ChangeEvent) => void;
  multiline?: boolean;
  placeholder?: string;
  inputRef?: TextInputRef | TextAreaRef;
  onChange?: (e: ChangeEvent) => void;
  value?: string;
}

export default function Input({
  type = "text",
  value,
  onChange,
  multiline,
  placeholder,
  inputRef,
  ...props
}: Props) {
  if (multiline) {
    return (
      <textarea
        ref={inputRef as TextAreaRef}
        placeholder={placeholder}
        className={styles.Input}
        value={value}
        onChange={onChange}
        {...props}
      />
    );
  }

  return (
    <input
      className={styles.Input}
      ref={inputRef as TextInputRef}
      placeholder={placeholder}
      type={type}
      value={value}
      onChange={onChange}
      {...props}
    />
  );
}
